import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';

export const Component = styled.div`
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -90%);
  user-select: none;
  pointer-events: none;
  min-width: 220px;
  padding: 6px;
  background: ${colors.white};
  border: 0.5px solid ${colors.gray400};
  border-radius: 8px;
  box-shadow: ${(props) => props.theme.blackShadow100};

  ${media.tablet(css`
    top: 100%;
    transform: translate(-50%, -100%);
  `)}
`;

export const Text = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: ${colors.black100};
`;
